
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/living",
      function () {
        return require("private-next-pages/world/living/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/living"])
      });
    }
  